<script>
  import FeriadoService from '../../../../domain/feriado/services/feriado'
  import { isArray } from 'lodash'
  import {list as listPatios} from '../../../../domain/patio/services/patio'

export default {
    components: {},
    nome: 'novo-feriado',
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          id: null,
          descricao: '',
          data: '',
          patios: []
        },
        loadingPatios: false,
        patios: []
      }
    },
    computed: {
      isMarcadosTodosOsPatios () {
        return this.patios.every(p => p.checked)
      }
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
      start () {
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Carregando')
          FeriadoService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              this.data.data = response.data.data.date.split(' ')[0]
              console.log(response)
              this.loadPatios(10000, 1, '')
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.isLoaded = true
          this.loadPatios(10000, 1, '')
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        const data = JSON.parse(JSON.stringify(this.data))
        data.patios = this.patios.filter(p => p.checked).map(p => p.id)
        FeriadoService.cadastrar(data, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      loadPatios (limit, page, filtros) {
        this.loadingPatios = true
        listPatios(limit, page, filtros)
          .then((response) => {
            this.patios = (response.data.result || []).map(patio => {
              patio.checked = this.data.patios.some(p => p.id === patio.id)
              return patio
            })
          })
          .catch((response) => {
            console.log(response)
          })
          .finally(() => {
            this.loadingPatios = false
          })
      },
      checkTodosOsPatios () {
        const marcar = !this.isMarcadosTodosOsPatios
        this.patios.forEach(p => { p.checked = marcar })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Feriado</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'config.feriado.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Descrição</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.descricao"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Data do Feriado</label>
                <div class="col-sm-8">
                  <input type="date" class="form-control" v-model="data.data"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Pátios fechados neste feriado:</label>
                <div class="col-sm-8">
                  <u-button class="btn btn-xs m-b-xs m-r-xs btn-info" @click="checkTodosOsPatios">
                    <i :class="`fa fa-${isMarcadosTodosOsPatios ? 'square-o' : 'check-square'}`"></i> {{isMarcadosTodosOsPatios ? 'Desmarcar' : 'Marcar'}} todos os pátios
                  </u-button>
                  <ul class="list list-unstyled">
                    <li v-for="patio in patios">
                      <input type="checkbox" :id="`patio-item-${patio.id}`" v-model="patio.checked">
                      <label :for="`patio-item-${patio.id}`">{{patio.nome}}</label>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.feriado.list'})">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoFeriado.vue?ebee1906